import { defineComponent as d, ref as i, computed as h, onMounted as _, watch as b, nextTick as w, withDirectives as z, openBlock as y, createBlock as k, unref as r, withCtx as I, createElementVNode as u, normalizeClass as C, normalizeStyle as S, renderSlot as V, vShow as A } from "vue";
import { popupProps as B, popupEmits as E } from "./popup.js";
import { ApOverlay as N } from "../overlay/index.js";
import { useNamespace as P } from "../../hooks/use-namespace.js";
import { useZIndex as Z } from "../../hooks/use-z-index.js";
import { addUnit as g } from "../../utils/style.js";
import "./popup.css";
const D = {
  role: "dialog",
  "aria-modal": "true",
  class: "ap-overlay-popup"
}, M = d({
  name: "ApPopup"
}), H = /* @__PURE__ */ d({
  ...M,
  props: B,
  emits: E,
  setup(m, { emit: c }) {
    const t = m, a = c, f = P("popup");
    i();
    const { nextZIndex: l } = Z(), o = i(!1), s = i(t.zIndex || l()), n = (e) => a("update:visible", e), v = h(() => {
      const e = {};
      return t.width && (e.width = g(t.width)), e;
    }), p = () => {
      o.value = !0, n(!0);
    }, x = () => {
      o.value = !1, n(!1);
    };
    return _(() => {
      t.visible && (o.value = !0, p());
    }), b(
      () => t.visible,
      (e) => {
        e ? (p(), s.value = t.zIndex ? s.value++ : l(), w(() => {
          a("open");
        })) : o.value && x();
      }
    ), (e, O) => z((y(), k(r(N), {
      mask: e.modal,
      "z-index": s.value
    }, {
      default: I(() => [
        u("div", D, [
          u("div", {
            class: C([r(f).b(), e.popupClass]),
            style: S(v.value),
            tabindex: "-1"
          }, [
            V(e.$slots, "default")
          ], 6)
        ])
      ]),
      _: 3
    }, 8, ["mask", "z-index"])), [
      [A, o.value]
    ]);
  }
});
export {
  H as default
};
